import { useQuery } from 'react-query';
import { queryGet } from '@pocapan/shared/utils/queryClient';

export interface ApiV1EventGoods {
  key: string;
  category: string;
  name: string;
}

export function useEventGoodsQuery(category?: string) {
  async function fetchEventGoods() {
    const queryParams = new URLSearchParams();
    if (category && category !== 'ALL') {
      queryParams.append('category', category);
    }
    const url = `/api/v1/event_goods${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const result = await queryGet(url);
    return result.eventGoods as ApiV1EventGoods[];
  }

  const { data, isLoading, isError } = useQuery(['EventGoods', category], fetchEventGoods, {
    cacheTime: 10 * 60 * 1000,
    staleTime: 10 * 60 * 1000,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false
  });

  return {
    data,
    isLoading,
    isError
  };
}
